// extracted by mini-css-extract-plugin
export var modal = "_w2-0";
export var table = "_w2-1";